import React from "react";
import RV from "simple-react-validator";
import ls from "local-storage";
import { Link } from "react-router-dom";
import * as CONFIG from "./_config";

class Signup extends React.Component {
  constructor(props) {
    super(props);
    this.validator = new RV();
    this.state = {};
  }

  componentDidMount() {
    if (ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`))
      window.location.href = "/";
  }

  showLogin(e) {
    let redirectToPath = window.location.pathname;

    if (window.location.hash !== "")
      redirectToPath = redirectToPath + window.location.hash;

    // console.log(window.location, window.location.hash, redirectToPath);
    // ls.set('redirectTo', redirectToPath);
    // ls.set('redirectTo',window.location.href);
    this.props.history.push("/login");
    return false;
  }

  showRegister(e) {
    let redirectToPath = window.location.pathname;

    if (window.location.hash !== "")
      redirectToPath = redirectToPath + window.location.hash;

    // console.log(window.location, window.location.hash, redirectToPath);
    // ls.set('redirectTo', redirectToPath);
    this.props.history.push("/simple-register");
    return false;
  }

  showLinkCardRegister(e) {
    let redirectToPath = window.location.pathname;

    if (window.location.hash !== "")
      redirectToPath = redirectToPath + window.location.hash;

    // console.log(window.location, window.location.hash, redirectToPath);
    // ls.set('redirectTo', redirectToPath);
    this.props.history.push("/link-card-registration");
    return false;
  }

  render() {
    return (
      <div>
        <div className="main-container full-width pt-5 mt-5  ">
          {CONFIG.DATA.THEME === 2 ? (
            <section
              id="apus-breadscrumb"
              className="breadcrumb-page apus-breadscrumb"
              style={{ backgroundColor: "#f3ffd9" }}
            >
              <div className="container">
                <div className="wrapper-breads">
                  <div className="wrapper-breads-inner">
                    <div className="breadscrumb-inner">
                      <h2 className="bread-title">Register</h2>
                      <ol className="breadcrumb">
                        <li>
                          <a href="/">Home</a>
                        </li>
                        <li>
                          <span>Register</span>
                        </li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          ) : (
            <div className="title-breadcrumb">
              <div className="container">
                <div className="title-breadcrumb-inner">
                  <header className="entry-header">
                    <h1 className="entry-title">Register</h1>
                  </header>
                  <div className="breadcrumbs">
                    <Link to="/">Home</Link>
                    <span className="separator">/</span>
                    <span> Register</span>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="row">
            <div
              className=" col-md-6 center pt-5"
              style={{ margin: "0px auto" }}
            >
              <div className="page-content pt-3">
                <div className="container">
                  <article
                    id="post-22"
                    className="post-22 page type-page status-publish hentry"
                  >
                    <div className="entry-content">
                      <div className="woocommerce">
                        <div className="woocommerce-notices-wrapper"></div>
                        <div>
                          <div className="row">
                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                              <Link
                                to="#"
                                onClick={(e) => {
                                  this.showRegister(e);
                                }}
                                className="btn btn-lg btn-primary px-5 text-white btn-lg btn-inline"
                              >
                                Register
                              </Link>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                              <Link
                                to="#"
                                onClick={(e) => {
                                  this.showLinkCardRegister(e);
                                }}
                                className="btn btn-lg btn-info ml-1 px-5 text-white btn-lg btn-inline"
                              >
                                Link Card Registration
                              </Link>
                            </div>
                            <p className="col-lg-8 col-sm-12 col-md-8 text-center mt-2 center">
                              OR
                            </p>
                            <div className="col-lg-8 col-sm-12 col-md-8 text-center mt-2 center">
                              <Link
                                to="#"
                                onClick={(e) => {
                                  this.showLogin(e);
                                }}
                                className="btn btn-lg btn-warning ml-1 px-5 text-white btn-lg btn-inline"
                              >
                                Sign In
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Signup;
